import React, { useState } from "react";
import { Drawer } from 'antd';
import { Link } from "react-router-dom";
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Button } from 'antd';

const Header = () => {

  const [open, setOpen] = useState(false);
  const setchange = () => {
    setOpen(!open)
  }
  const menu = (
    <Menu>
      <Menu.Item key="driver">
        <a href="https://apply.srtranspor.com/apply/otrdriver" target="_blank" rel="noopener noreferrer">
         OTR-Driver
        </a>
      </Menu.Item>
      <Menu.Item key="owner-operator">
        <a href="https://apply.srtranspor.com/apply/owneroperator" target="_blank" rel="noopener noreferrer">
          Owner Operator
        </a>
      </Menu.Item>
    </Menu>
  );
  return (
    <>
      <header className="main-header">
        <div className="container">
          <div className="main-header-wapper">
            <div className="site-logo">
              <Link to="/">
                <img src="images/logo.png" alt="Logo" />
              </Link>
            </div>
            <div className="main-header-info">
              <div className="top-header">
                <ul className="top-left">
                  <li>
                    <a href="mailto:'humanresource@srtranspor.com'">   <i className="fa-solid fa-envelope" />
                      &nbsp;
                      humanresource@srtranspor.com
                    </a>
                  </li>
                  <li>
                    <a href="tel:'3017097924'"> <i class="fa-solid fa-phone"></i>
                      &nbsp;
                      (301) 709-7924
                    </a>
                  </li>
                  <li>
                    <i class="fa-solid fa-location-dot"></i>
                    &nbsp;
                    9528 Baltimore, Ave
                    Laurel, MD 20723
                  </li>

                  <br /> <br />
                </ul>
                <div className="top-right">
                  <ul className="header-social-share"></ul>
                </div>
              </div>
              {/*/.top-header*/}
              <div className="header-menu-wrap">
                <ul className="nav-menu">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/aboutus">About Us</Link>
                  </li>
                  <li>
                    <Link to="/services">Our Services</Link>
                  </li>
                  <li>
                    <Link to="/testinomials">Testimonials</Link>
                  </li>
                  <li>
                    <Link to="https://apply.srtranspor.com">Contact Us</Link>
                  </li>
                  {/* <li>
                    <Link to="/resources">Resources</Link>
                  </li> */}
             
                </ul>
                <div className="menu-right-item">
                  <div className="mobile-menu-icon" onClick={() => { setchange() }}>
                    <i class="fa-solid fa-bars"></i>              </div>
               {/* <Link
                    to="https://apply.srtranspor.com/"
                    className="default-btn d-none d-lg-block  d-md-block"
                  >
                    <i class="fa-solid fa-truck-fast"></i>                Apply Now {" "}
                  </Link> */}
                  <Dropdown overlay={menu}>
      <Button className="default-btn d-none d-lg-block  d-md-block" style={{height:"50px"}} >
       Careers <DownOutlined />
      </Button>
    </Dropdown>    
                </div>
              </div>
              {/*/.header-menu-wrap*/}
            </div>
          </div>
        </div>
      </header>
      <Drawer
        placement="left"
        open={open}
        key="left"
        closable={false}
        style={{ background: "#04223e" }}
      >
        <div className="d-flex justify-content-between">
          <Link to="/">
            <img src="images/logo.png" width="150px" alt="Logo" />
          </Link>
          <i onClick={() => { setOpen(false) }} style={{ fontSize: "40px", color: "#fff" }} className="fa-solid fa-xmark"></i>
        </div>
        <ul className="nav-menu" >
          <li style={{ marginTop: "15px" }}>
            <Link style={{ color: "#fff" }} to="/">Home</Link>
          </li>
          <li style={{ marginTop: "15px" }}>
            <Link style={{ color: "#fff" }} to="/aboutus">About Us</Link>
          </li >
          <li style={{ marginTop: "15px" }}>
            <Link style={{ color: "#fff" }} to="/services">Our Services</Link>
          </li>
          <li style={{ marginTop: "15px" }}>
            <Link style={{ color: "#fff" }} to="/testinomials">Testimonials</Link>
          </li>
          <li style={{ marginTop: "15px" }}>

            <Link style={{ color: "#fff" }} to="/contact">Contact Us</Link>
          </li>
     
          <li style={{ marginTop: "15px" }}>

<Link style={{ color: "#fff" }} to="/resources">Resources</Link>
</li>
       

          <li style={{ marginTop: "15px" }}>
         
            <Dropdown overlay={menu}>
      <Button className="default-btn d-lg-block d-md-block" style={{height:"50px"}} >
       Careers <DownOutlined />
      </Button>
    </Dropdown>    
          </li>
        </ul>
    
        <Dropdown overlay={menu}>
      <Button className="default-btn d-none d-lg-block  d-md-block" style={{height:"50px"}} >
       Careers <DownOutlined />
      </Button>
    </Dropdown>    
      </Drawer>
    </>
  );
};

export default Header;
